<cp-base-notification contentClassName="info" wrapperClassName="info">
  <ng-container header>
    <div class="compliance-lapsed-notification__icon">
      <ui-svg-icon
        iconClassName="icon-notification--expired"
        svgId="alert-filled"
      ></ui-svg-icon>
    </div>
    <span>Your registration has lapsed</span>
    <div class="compliance-lapsed-notification__cta"></div>
  </ng-container>
  <ng-container content>
    <p class="compliance-lapsed-notification__paragraph">
      Your registration with us has unfortunately lapsed due to now working a
      shift for over 3 months. Don't worry - you're still eligible to work with
      us! To keep your registration active and continue working shifts, we
      encourage you to regularly pick up shifts when available.
    </p>
    <p class="compliance-lapsed-notification__paragraph">
      Please visit
      <a
        [href]="qnUrl"
        class="compliance-lapsed-notification__book-shift-link"
        target="_blank"
        >Quick Nurse</a
      >
      to find and book available shifts, so you can restore and maintain your
      active status.
    </p>
  </ng-container>
</cp-base-notification>
